import { memo } from 'react';
import { MenuItem } from 'consts/openBanking';
import { selectIsExportOpenBankingResourceLoading } from 'features/openBanking/selectors';
import { TableToolbar, type TableToolbarProps } from 'ui/widgets/Table';

const BankingSDKToolbar = (props: Pick<TableToolbarProps, 'onExport'>) => (
    <TableToolbar
        {...props}
        selectIsExportLoading={selectIsExportOpenBankingResourceLoading(MenuItem.BankingSDK)}
        dataTestIdPrefix='openBanking.table'
    />
);

export default memo(BankingSDKToolbar);
